import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HbrButton } from '@harbor/elements-react-standalone';

type Props = {
  title?: string;
  message?: string;
};

export default function Unauthorized({
                                       title = 'Unauthorized',
                                       message = `You don't have permission to access this page.`,
                                     }: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div style={{ padding: 24, maxWidth: 900 }}>
      <h2 style={{ marginTop: 0, marginBottom: 8 }}>{title}</h2>
      <p style={{ marginTop: 0, marginBottom: 16 }}>{message}</p>

      <p style={{ marginTop: 0, marginBottom: 16, opacity: 0.75 }}>
        Path: <code>{location.pathname}</code>
      </p>

      <div style={{ display: 'flex', gap: 12 }}>
        <HbrButton onClick={() => navigate('/')}>Go to Home</HbrButton>
        <HbrButton sentiment="secondary" onClick={() => navigate(-1)}>
          Go Back
        </HbrButton>
      </div>
    </div>
  );
}